module.exports = __webpack_public_path__ + "img/power-off.649053fd.svg";